import axios from 'axios';
import { from } from 'rxjs';

export const getOrderAlertsCounts = () => from(axios.get('/alerts/counts').then((response) => response.data));

export const getOrderAlerts = (page, pageSize) =>
  axios.get(`/seller/alerts?page=${page}&pageSize=${pageSize}`).then((response) => response.data.pageData);
